<div class="wrapper" [class.wrapper_thin]="collapsed !== undefined">
  <!--  <div class="head">-->
  <!--    <span class="title">Deliveroo</span>-->
  <!--  </div>-->
  <div class="content">
    <div [class.first-line]="collapsed !== undefined">
      <div>
        <div class="label" style="margin-top: 0">
          {{'MENU.CONNECTED_SERVICE' | translate}}
        </div>

        <div class="text">
          {{ serviceName }}
        </div>
      </div>
      <div *ngIf="collapsed !== undefined">
        <button mat-icon-button (click)="toggleCollapse()">
          <mat-icon *ngIf="collapsed === true">keyboard_arrow_left</mat-icon>
          <mat-icon *ngIf="collapsed === false">keyboard_arrow_up</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="collapsed === false || collapsed === undefined">
      <div *ngIf="lastSync">
        <div class="label">
          {{'MENU.SYNC.LAST_SYNC' | translate}}
        </div>

        <div class="text">
          {{ lastSync | moment: 'lll' : true }}
        </div>
      </div>

      <!--        <div class="label">-->
      <!--          {{'MENU.MODIFIED' | translate}}-->
      <!--        </div>-->

      <!--        <div class="text">-->
      <!--          Aug 30, 2021, 12:34-->
      <!--        </div>-->

      <!--        <mat-slide-toggle class="auto-publish">{{'MENU.AUTOPUBLISHING' | translate}}</mat-slide-toggle>-->

      <div class="publish">
        <button mat-button
                [disabled]="isLoading"
                (click)="handleSync()">{{isLoading ? ('COMMON.LOADING' | translate) : ('MENU.SYNC.SYNCHRONIZE' | translate)}}
        </button>
        <div class="published" *ngIf="past">
          {{getSynchronizedText()}}
        </div>
      </div>
      <div *ngIf="!!error" class="error">
        {{ error }}
      </div>
    </div>

  </div>
  <!--  <div class="actions">-->
  <!--    <div class="actions-left">-->
  <!--      <button mat-button class="actions-button">Edit</button>-->
  <!--      <button mat-button class="actions-button">Copy</button>-->
  <!--    </div>-->
  <!--    <div class="actions-right">-->
  <!--      <button mat-button class="actions-button actions-button_delete">-->
  <!--        <mat-icon>delete</mat-icon>-->
  <!--        {{'MENU.DELETE' | translate}}-->
  <!--      </button>-->
  <!--    </div>-->
  <!--  </div>-->
</div>
